export const customerTypes = {
  COMPANY: 'company',
  PERSONAL: 'personal',
}
